import React from "react";

const ComoAyudo = () => {
    return(
        <div className="container p-3 text-center bw-bold">
            <h1 id="ComoTeAyudo"className="">¿Cómo te puedo ayudar?</h1>
            <div>
                <p className="bw-bold fs-5">Con la terapia psicológica aprendes a disfrutar del presente, a valorar las experiencias, a prestar tu atención a las cosas importantes, a distribuir tus energías de manera saludable en los temas y en los tiempos apropiados, a buscar y encontrar lo que deseas.
</p>
                </div>
            <div className="row ">
            
                <div className="col p-4">
                <div className="row row-cols-1 row-cols-md-3 g-4">
  <div className="col">
    <div className=" border border-0  h-100">
      <img src="./Images/Animo.png" className="card-img-top" alt="Estados de ánimo"/>
      <div className="card-body">
        <h4 className="card-title">Estados de ánimo</h4>
        <p className="card-text p-3 "> Los estados de ánimo varían durante el día, pero el cambio de ellos te produce incomodidad, molestia, dolor, cuando se polarizan las emociones continuamente y no sabes regularlas. Desde la terapia, aprenderás a gestionar las emociones que exceden tus posibilidades de asumirlas y tramitarlas.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/RelacionesPersonales.jpg" className="card-img-top" alt="Relaciones personales"/>
      <div className="card-body">
        <h4 className="card-title">Relaciones personales</h4>
        <p className="card-text  p-3">Somos seres sociales, nos constituimos y aprendemos a vivir en sociedad. Siempre las relaciones con otros conllevan un choque de individualidades que fueron constituidas y formadas de manera diferente. Por ello es que duele vincularse con otros. Porque están en juego tus creencias, valores, modos de resolver los conflictos que se oponen a las del otro. En la terapia encontrarás alternativas para vincularte de manera armónica y empática con los demás.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Miedos.jpg" className="card-img-top" alt="Miedos"/>
      <div className="card-body">
        <h4 className="card-title">Miedos</h4>
        <p className="card-text  p-3">Las propuestas de la realidad y los escasos recursos internos y externos que tienes para asumirlas, pueden paralizar tus decisiones y detenerte por años en aquello que deseas. A través de la terapia, encontrarás nuevas respuestas para analizar la realidad y dar una respuesta saludables con las decisiones correctas que aprendas a tomar.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Estres.jpg" className="card-img-top" alt="Estrés"/>
      <div className="card-body">
        <h4 className="card-title">Estrés y cansancio</h4>
        <p className="card-text  p-3">Estamos expuestos permanentemente a factores estresantes ya sea en el trabajo o en las relaciones con los amigos y la familia. Aprender a afrontar el estrés es una de las riquezas más valoradas por quienes se animan a empezar terapia.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Ansiedad.jpg" className="card-img-top" alt="Ansiedad"/>
      <div className="card-body">
        <h4 className="card-title">Ansiedad</h4>
        <p className="card-text  p-3">Con la terapia psicológica, podes acceder a una mejor calidad de vida, superando las limitaciones del buen vivir.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Autoestima.jpg" className="card-img-top" alt="Autoestima"/>
      <div className="card-body">
        <h4 className="card-title">Autoestima</h4>
        <p className="card-text  p-3">La baja estima de uno mismo, produce excesivas atenciones hacia los otros, desviando las energías que podrìas emplear para lograr tus proyectos. En la terapia psicológica te reencontrarás con vos como ser amoroso para  reconocer como válidos tus deseos y necesidades.
</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Obsesion.jpg" className="card-img-top" alt="Obsesiones"/>
      <div className="card-body">
        <h4 className="card-title">Obsesiones</h4>
        <p className="card-text  p-3">En ocasiones desarrollamos ciertos TOCs que limitan la capacidad de tomar decisiones y de seguir adelante con aquello que deseamos. El profesional psicólogo es quien está preparado científicamente para abordar este tipo de neurosis y sanarte.

</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Histeria.jpg" className="card-img-top" alt="Histeria"/>
      <div className="card-body">
        <h4 className="card-title">Histeria</h4>
        <p className="card-text  p-3">La encontramos en aspectos de nuestra personalidad que nos hacen decir algo que no queremos expresar.  Si la histeria se va al cuerpo, se nos presenta con diferentes síntomas que tienen su origen en el psiquismo. Los psicólogos sabemos diagnosticar y abordar este tipo de neurosis.

</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="border border-0  h-100">
      <img src="./Images/Sueños.jpg" className="card-img-top" alt="Interpretación de los sueños"/>
      <div className="card-body">
        <h4 className="card-title">Interpretación de los sueños</h4>
        <p className="card-text  p-3">Es la vía regia para acceder a lo inconsciente de nuestra psiquis. En terapia los sueños ayudan a conocer e integrar aspectos de nuestra personalidad que están latentes en él mismo.

</p>
      </div>
    </div>
  </div>
</div>


                </div>
            </div>
            </div>
            
   
    )
}

export default ComoAyudo;